<template>
  <b-list-group flush>
    <b-list-group-item
      v-for="cp in complainData"
      :key="cp.id"
    >
      <ComplainDetailInput
        :data-i="cp"
        :is-read-only="ReadOnly"
        @handle-deleted="onDeletedBtnClicked"
      />

    </b-list-group-item>
  </b-list-group>

</template>

<script>
import {
  BRow, BCol, BFormTextarea, BCard, BFormRadio, BTab, BTabs, BButton, BListGroupItem, BListGroup,
} from 'bootstrap-vue'
import ComplainDetailInput from './ComplainDetailInput.vue'

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BListGroupItem,
    BListGroup,
    ComplainDetailInput,
  },
  props: {
    dataD: {
      type: Array,
      required: true,
    },
    ReadOnly: String,
  },
  setup(props) {
    return {
      complainData: props.dataD,
      // ReadOnly: props.IsReadOnly,
    }
  },
  methods: {
    onDeletedBtnClicked(id) {
      this.$emit('handle-deleted', id)
    },
  },

}
</script>

<style>

</style>
